import React from 'react';
import { Outlet } from 'react-router-dom';
export { default as groupRoutes } from './routes';

export default function () {
  return <Outlet />;
}
